var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsb({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "52AD4A9D-3151-44C0-AC45-0D9B550FB875") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Entertainment",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Entertainment/USB/24",
    fill: "#00095B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2163016,6.04686448 L18.2163016,9.43726374 L17.0861685,9.43726374 L17.0861685,11.2304386 C17.0861685,11.6758842 16.9050282,12.1133551 16.5894568,12.4289265 L12.730827,16.2886956 C12.624877,16.3946455 12.5656362,16.5359122 12.5656362,16.6851535 L12.5656362,19.7132722 C13.2218425,19.9468179 13.6957693,20.5677075 13.6957693,21.3048004 C13.6957693,22.2401222 12.9358915,23 12.0005696,23 C11.0641085,23 10.30537,22.2401222 10.30537,21.3048004 C10.30537,20.5677075 10.7781575,19.9468179 11.4343638,19.7132722 L11.4343638,18.9476982 C11.4343638,18.7961783 11.375123,18.6549117 11.2680338,18.5478225 L7.41054321,14.6880534 C7.08927554,14.3690643 6.91269225,13.9429859 6.91269225,13.4895655 L6.91269225,11.5938584 C6.25648594,11.3603128 5.78369841,10.7394231 5.78369841,10.0023303 C5.78369841,9.06586919 6.54243695,8.30713065 7.47889804,8.30713065 C8.41535912,8.30713065 9.17409766,9.06586919 9.17409766,10.0023303 C9.17409766,10.7405624 8.70017089,11.361452 8.04282533,11.5949977 L8.04282533,13.4895655 C8.04282533,13.6410854 8.10206618,13.782352 8.2091554,13.8894413 L11.4355031,17.1157889 L11.4355031,4.91559215 L9.74030345,4.91559215 L12.0005696,1 L14.2596965,4.91559215 L12.5656362,4.91559215 L12.5656362,14.8543835 L15.7897053,11.6291751 C15.8956553,11.5243644 15.9560354,11.3785407 15.9560354,11.2304386 L15.9560354,9.43726374 L14.8259023,9.43726374 L14.8259023,6.04686448 L18.2163016,6.04686448 Z",
    id: "USB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsb);
export default __webpack_public_path__ + "static/media/usb.5eb82bf8a3d3d4c37def0ce54fc04d2e.svg";
export { ForwardRef as ReactComponent };